import Images_Prd from "./Images_Prd";
import ImageCanvasTools_Prd from "./ImageTools/ImageCanvasTools_Prd";
import FileUpload_Prd from "./FileUpload_Prd";
import WordMultiple_Prd from "./WordMultiple_Prd";
import ImagesPresets_Prd from "./ImagesPresets_Prd";
import TextOnly_Prd from "./TextOnly_Prd";
import TextLogo_Prd from "./TextLogo_Prd";
import Extra_Prd from "./Extra_Prd";
import TextEditActions from "./TextTools/TextEditActions";
import ProductContainer from "./ProductContainer";
import ImageTools from "./ImageTools";
import ProductControls from "./ProductControls";
import TextTools from "./TextTools";
import CanvasComponents from "./Canvas";

export default {
  Images_Prd,
  ImageCanvasTools_Prd,
  FileUpload_Prd,
  WordMultiple_Prd,
  ImagesPresets_Prd,
  TextOnly_Prd,
  TextLogo_Prd,
  Extra_Prd,
  TextEditActions,
  ProductContainer,
  ProductControls,
  ...ImageTools,
  ...TextTools,
  ...CanvasComponents,
};
